import React, { Component } from 'react'
import Select from 'react-select';
import { Row, Col, Table, Popover, OverlayTrigger } from "react-bootstrap";
import { toast } from 'react-toastify';
import CustomModal from "../../../components/Modal/CustomModal";
import ModalForm from "../../../components/Modal/ModalForm";

import { ConsultaEventEx, AddNewEvento, DelEvento, ConsultaColores, ConsultaRangoEventos } from '../../../funciones/AgendaFunction';
import EditEvent from './EditEvent';

let idEvent = "";

class AddEvento extends Component {
    state = {
        eventos: [],
        fecha: "",
        preloader: {
            text: "",
            icon: ""
        },
        dEvent: "",
        valorColor: { value: '', label: '888888' },
        colores: [],
        quien: { value: '', label: '- ¿Quién puede ver esto? -' },
        quienes: [
            {value: 1, label: "Todos"},
            {value: 2, label: "Solo yo"},
            {value: 3, label: "Directivos"},
            {value: 4, label: "Profesores"},
            {value: 5, label: "Estudiantes"},
            {value: 6, label: "Directivos y Profesores"},
            {value: 7, label: "Profesores y Estudiantes"},
            {value: 8, label: "Directivos y Estudiantes"}
        ],
        boton1: {
            text:"Si",
            icon: "fa fa-check"
        },
        boton2: {
            text:"Agregar",
            icon: "fa fa-plus"
        },
        cantErrores: "",
        verEvents: false,
        cantFechasDpl: 0,
        fechasDpl: [],
        openConfirm: false,
        openDel: false,
        openEdit: false
    }

    constructor (props) {
        super (props);
        ConsultaColores ( (resp) => {
            this.setState({
                colores: resp
            })
        })
    }

    EventosRangoF = () => {
        let fechaIn = document.getElementById("fechaIn").value;
        let fechaOut = document.getElementById("fechaOut").value;
        
        let fechaI = fechaIn.split("/").reverse().join("/");
        let fechaF = fechaOut.split("/").reverse().join("/");

        let fechaInicio = new Date(fechaI);
        let fechaFin = new Date(fechaF);
        let contenido = [fechaIn];

        while(fechaFin.getTime() > fechaInicio.getTime()){
            fechaInicio.setDate(fechaInicio.getDate() + 1);

            let dia = fechaInicio.getDate();
            let mes = fechaInicio.getMonth() + 1;
            let year = fechaInicio.getFullYear();

            if (dia < 10) dia = `0${dia}`
            if (mes < 10) mes = `0${mes}`
            
            contenido.push(
                `${dia}/${mes}/${year}`
            )
        }

        ConsultaRangoEventos (contenido, (resp) => {
            this.setState({
                eventos: resp,
                openConfirm: false,
                openDel: false,
                openEdit: false
            })
        })
    }

    buscarEventosRango = () => (e) => {
        let fechaIn = document.getElementById("fechaIn").value;
        let fechaOut = document.getElementById("fechaOut").value;

        if(fechaIn === "" || fechaOut === "") {
            toast.error("Selecciona primero una fecha o un rango de fechas",{autoClose: 4000});
            return null;
        }

        this.setState({
            openConfirm: false,
            openDel: false,
            openEdit: false,
            verEvents: true,
            preloader: {
                text: "Buscando eventos, espera por favor",
                icon: "fa fa-spinner fa-spin"
            }
        },() => {
            let fechaI = fechaIn.split("/").reverse().join("/");
            let fechaF = fechaOut.split("/").reverse().join("/");

            let fechaInicio = new Date(fechaI);
            let fechaFin = new Date(fechaF);
            let contenido = [fechaIn];

            while(fechaFin.getTime() > fechaInicio.getTime()){
                fechaInicio.setDate(fechaInicio.getDate() + 1);

                let dia = fechaInicio.getDate();
                let mes = fechaInicio.getMonth() + 1;
                let year = fechaInicio.getFullYear();

                if (dia < 10) dia = `0${dia}`
                if (mes < 10) mes = `0${mes}`
                
                contenido.push(
                    `${dia}/${mes}/${year}`
                )
            }

            ConsultaRangoEventos (contenido, (resp) => {
                this.setState({
                    eventos: resp,
                    preloader: {
                        text: "",
                        icon: "*"
                    }
                })
            })
        })
    }

    valorQuien = (quien) => {
        this.setState({
            quien,
            openConfirm: false,
            openDel: false,
            openEdit: false
        })
    }

    cambiaValor = (prop) => (event) => {
        this.setState({
            [prop]: event.target.value,
            openConfirm: false,
            openDel: false,
            openEdit: false
        });
    };

    fechaLarga = () => {
        let diaSep = this.props.dia.split("/");
        let meses = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"]
        return `${diaSep[0]} de ${meses[diaSep[1]-1]} de ${diaSep[2]}`
    }

    openDel = (id) => (e) => {
        idEvent = id

        this.setState ({
            openConfirm: false,
            openDel: true,
            openEdit: false,
        })
    }

    openEditM = (id) => (e) => {
        idEvent = id

        this.setState ({
            openConfirm: false,
            openDel: false,
            openEdit: true
        })
    }

    cerrarModalEdit = () => (e) => {
        this.setState ({
            openConfirm: false,
            openDel: false,
            openEdit: false
        })
    }

    contenidoTable = () => {
        let { eventos } = this.state;

        let mediaFecha = (fecha) => {
            let fechaDes = fecha.split("/");
            let meses = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"]

            return `${fechaDes[0]} de ${meses[parseInt(fechaDes[1]) - 1]} de ${fechaDes[2]}`
        }

        let eventosF = (eventosFechaInd) => {
            if(eventosFechaInd.length === 0) return (
                <div className="text-muted" style={{fontSize: 10}}>No existen eventos para esta fecha</div>
            )

            return(
                <Table hover striped style={{border:"1px solid #CCC"}}>
                    <tbody>
                        {eventosFechaInd.map(option => (
                            <tr key ={option[0].id}>
                                <td width={20} style={{borderLeft:`solid 3px #${option[0].codigo_color}`, padding:5}} align="center">
                                    <i className="fa fa-circle" style={{color: option[0].codigo_color, fontSize: 10}}></i>
                                </td>
                                <td style={{padding: 5, fontSize: 10}}>
                                    {option[0].event_name}
                                </td>
                                <td width={150} style={{padding: 5, fontSize: 10, borderRight:`solid 3px #${option[0].codigo_color}`}} align="right">
                                    <div className="btn-group">
                                        <button className="btn btn-warning" onClick={this.openEditM(option[0].id)} title= "Editar este evento" style={{borderWidth: 1}}><i className="fa fa-edit"></i></button>
                                        <button className="btn btn-danger" onClick = {this.openDel(option[0].id)} title= "Eliminar este evento" style={{borderWidth: 1}}><i className="fa fa-times"></i></button>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            )
        }

        return (
            eventos.map(option => (
                <React.Fragment>
                    <div className="custom-alert-warning" style={{marginBottom: 5, fontSize:10}}>
                        Eventos del día <strong>{mediaFecha(option.Fecha)}</strong>
                    </div>
                    <div className="table-responsive" style={{padding: 10, paddingRight: 0}}>
                        {eventosF(option.Coincidencias)}
                    </div>
                </React.Fragment>
            ))
        )
    }

    cancelar = () => {
        this.setState({
            dEvent: "",
            valorColor: { value: '', label: '888888' },
            quien: { value: '', label: '- ¿Quién puede ver esto? -' },
        })
    }

    respuestaGuardar = (resp) => {
        let mensaje = resp[1];
        let errores = resp[2];
        let nameErrores = resp[3]
        let contentErr = [];

        let erroresList = (
            <Popover bsSize="large" title="Errores Encontrados" id="erroresList">
                {contentErr}
            </Popover>
        )

        let respOk = (mensaje) => {

            this.EventosRangoF()

            this.setState({
                boton1:{
                    text:"Si",
                    icon: "fa fa-check"
                },
                boton2:{
                    text:"Agregar",
                    icon: "fa fa-plus"
                }
            }, () => {
                toast[mensaje.status](mensaje.mensaje,{autoClose: 4000});
            })
        }

        for (let i in nameErrores) {
            if (nameErrores[i] !== "") contentErr.push(
                <div key = {i} className="text-danger" style={{fontSize:10, marginBottom:8}}><i className="fa fa-exclamation-triangle"></i> {nameErrores[i]}</div>
            )
        }

        if (errores === 0) {
            this.cancelar()
            this.setState({ cantErrores:"" })
        }
        if (mensaje[0].status === "error" && errores !== 0) this.setState ({
            cantErrores: <div style={{paddingTop:10}}>
                            Se han encontrado {errores} error(es). Haz click <span>
                            <OverlayTrigger trigger="focus" placement="top" overlay={erroresList}>
                                <button style={{borderWidth: 1}} className="btn btn-danger btn-xs">Aqui</button> 
                            </OverlayTrigger></span> para verlos
                        </div>
        })

        respOk(mensaje[0]);
    }

    eventosFecha = (status) => {
        
        if (status === false) return null;
        
        return this.contenidoTable()
    }

    confirmacion = () => {
        let { valorColor, quien, boton1, dEvent, openConfirm, cantFechasDpl, fechasDpl } = this.state;

        let mediaFecha = (fecha) => {
            let fechaDes = fecha.split("/");
            let meses = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"]

            return `${fechaDes[0]} de ${meses[parseInt(fechaDes[1]) - 1]} de ${fechaDes[2]}`
        }

        let eventosFechas = (eventos) => (
            eventos.map(option => (
                <tr key ={option[0].id}>
                    <td style={{padding: 5, fontSize: 10, borderLeft:`solid 3px #${option[0].codigo_color}`,
                        borderRight:`solid 3px #${option[0].codigo_color}`}}>
                        {option[0].event_name}
                    </td>
                </tr>
            ))
        )

        let MainFechas = (
            <Popover title="Lista de Eventos del Rango" id="eventos">
                <div align="center" style={{maxHeight: 300, overflowY: "auto"}}>
                    {fechasDpl.map(option => (
                        <React.Fragment key={Math.round(Math.random()*100000)}>
                            <div className="custom-alert-warning"  align="left" style={{marginBottom: 10, fontSize: 10}}>
                                <strong>{mediaFecha(option.Fecha)}</strong>
                            </div>
                            <Table striped hover>
                                <tbody>
                                    {eventosFechas(option.Coincidencias)}
                                </tbody>
                            </Table>
                        </React.Fragment>
                    ))}
                </div>
            </Popover>
        )


        let contenidoModal = <React.Fragment>
                <div>
                El rango seleccionado posee <strong><span className="text-info">{cantFechasDpl} fecha(s) con evento(s).</span></strong>  ¿Deseas continuar?
                </div>
                
                <OverlayTrigger trigger="focus" placement="left" overlay={ MainFechas }>
                    <button className="btn btn-primary" style={{borderWidth:1}} title="Eventos"><i className="fa fa-list"></i> Ver Eventos</button>
                </OverlayTrigger>
            </React.Fragment>
        return (
            <CustomModal
                isopen =  {openConfirm}
                titulo = {<div className="text-primary">Confirmación</div>}
                contenido = {contenidoModal}
                boton1 = {<React.Fragment><i className={boton1.icon}></i> {boton1.text}</React.Fragment>}
                boton2 = {<React.Fragment><i className="fa fa-times"></i> No</React.Fragment>}
                funcion1 = { () => {
                    this.setState({
                        boton1: {
                            text:"Espera",
                            icon: "fa fa-spinner fa-spin"
                        }
                    }, () => {
                        let fechaIn = document.getElementById("fechaIn").value;
                        let fechaOut = document.getElementById("fechaOut").value;
                        let campos = {
                            valorColor, quien, dEvent,
                            fechaIn, fechaOut
                        }
                        AddNewEvento(campos, (resp) => {
                            this.respuestaGuardar(resp)
                            this.setState({
                                openConfirm: false,
                                openDel: false,
                                openEdit: false
                            })
                        })
                    })
                }}/>
        );
    }

    delEvento = () => {
        let { boton1, openDel } = this.state;

        let contenidoModal = <React.Fragment>
                <div>¿Deseas realmente <strong className="text-danger">Eliminar</strong> este evento?</div>
                <div className="text-muted" style={{fontSize: 10}}>Esta opción elminará el evento de todas las fechas y no puede deshacerse</div>
            </React.Fragment>
        return (
            <CustomModal
                isopen =  {openDel}
                titulo = {<div className="text-primary">Confirmación</div>}
                contenido = {contenidoModal}
                boton1 = {<React.Fragment><i className={boton1.icon}></i> {boton1.text}</React.Fragment>}
                boton2 = {<React.Fragment><i className="fa fa-times"></i> No</React.Fragment>}
                funcion1 = { () => {
                    this.setState({
                        boton1: {
                            text:"Espera",
                            icon: "fa fa-spinner fa-spin"
                        }
                    }, () => {
                        DelEvento (idEvent, () => {
                            this.setState({
                                boton1: {
                                    text:"Si",
                                    icon: "fa fa-check"
                                },
                                openDel: false,
                                openEdit: false
                            }, () => {
                                this.EventosRangoF();
                                toast.error("El Evento ha sido correctamente eliminado",{autoClose: 4000})
                            })
                        })
                    })
                }}
            />
        );

    }

    modalEditEvent = () => {
        let { quienes, colores } = this.state;
        let contenidoModal = () => (<EditEvent
            id = {idEvent} quienes={quienes} colores ={colores}
            funcion = {
                () => {
                    this.EventosRangoF();
                    this.setState({
                        openEdit: false
                    })
                }
            }
            />);
        const { openEdit } = this.state;
        return (
            <ModalForm
                isopen =  {openEdit}
                titulo = {<div>Editar Evento</div>}
                contenido = {contenidoModal()}
                cerrar = {this.cerrarModalEdit}
            />
        );
    }

    contenidoAdd = () => {
        let { valorColor, colores, quien, quienes, boton2, dEvent, cantErrores } = this.state;

        let cambiaColor = (color) => (e) => {
            this.setState({
                valorColor: color,
                openConfirm: false,
                openDel: false,
                openEdit: false
            })
        }

        let coloresD = () => (
            colores.map(option => (
                <span style={{paddingLeft: 5, paddingTop: 5, paddingBottom: 5,}} key={Math.round(Math.random()*100000)}>
                    <i className="fa fa-square" onClick={cambiaColor(option)} title={option.label} style={{color: option.label, cursor:"pointer"}}></i>
                </span>
            ))
        )

        let MainColor = (
            <Popover title="Colores Disponibles" id="colores">
                <div align="center" style={{height: 100, width:150}}>
                    {coloresD()}
                </div>
            </Popover>
        )

        const customStyles = (base) => ({
            ...base,
            fontSize: 10,
        });

        return (
            <React.Fragment>
                <div className="custom-alert-warning" style={{padding: 5}}>
                    <div>Agregar un Nuevo Evento</div>
                    <Row>
                        <Col md={3}>
                            <input type="text" id="fechaIn" disabled className="form-control" placeholder="DD/MM/AAAA"/>
                            <span className="text-muted" style={{fontSize: 10}}>Desde</span>
                        </Col>
                        <Col md={3}>
                            <input type="text" id="fechaOut" disabled className="form-control" placeholder="DD/MM/AAAA"/>
                            <span className="text-muted" style={{fontSize: 10}}>Hasta</span>
                        </Col>
                        <Col md={6}>
                            <Select
                                styles={{menu: customStyles}}
                                isSearchable ={true}
                                value={quien}
                                onChange={this.valorQuien}
                                options={quienes}
                            />
                            <span className="text-muted" style={{fontSize: 10}}>Compartir</span>
                        </Col>
                        <Col md={7} className="custom-mt-10">
                            <textarea className="form-control" placeholder="Descriṕción del evento" onChange={this.cambiaValor("dEvent")} value={dEvent}></textarea>
                        </Col>
                        <Col md={5} className="custom-mt-10" align="right">
                            <OverlayTrigger trigger="focus" placement="top" overlay={ MainColor }>
                                <button className="btn btn-default" style={{borderWidth:1, borderColor:"CCC", backgroundColor: "FFF", color: valorColor.label}} title="Selecciona un Color"><i className="fa fa-square"></i> Selecciona un color <i className="fa fa-caret-up"></i></button>
                            </OverlayTrigger>
                        </Col>
                    </Row>
                </div>
                <Row className="custom-mt-10">
                    <Col md={7}>
                        <div className="text-danger">{ cantErrores }</div>
                    </Col>
                    <Col md={5} align="right">
                        <button className="btn btn-primary" style={{borderWidth: 1}}
                        onClick ={()=> {
                            this.setState({
                                openConfirm: false,
                                openDel: false,
                                openEdit: false,
                                boton2: {
                                    text:"Espera",
                                    icon: "fa fa-spinner fa-spin"
                                }
                            }, () => {

                                let fechaIn = document.getElementById("fechaIn").value;
                                let fechaOut = document.getElementById("fechaOut").value;
                                let fechaI = fechaIn.split("/").reverse().join("/");
                                let fechaF = fechaOut.split("/").reverse().join("/");
                                let fechaInicio = new Date(fechaI);
                                let fechaFin = new Date(fechaF);
                                let contenido = [fechaIn];
                        
                                while(fechaFin.getTime() > fechaInicio.getTime()){
                                    fechaInicio.setDate(fechaInicio.getDate() + 1);
                        
                                    let dia = fechaInicio.getDate();
                                    let mes = fechaInicio.getMonth() + 1;
                                    let year = fechaInicio.getFullYear();
                        
                                    if (dia < 10) dia = `0${dia}`
                                    if (mes < 10) mes = `0${mes}`
                                    
                                    contenido.push(
                                        `${dia}/${mes}/${year}`
                                    )
                                }

                                let campos = {
                                    valorColor, quien, dEvent,
                                    fechaIn, fechaOut, contenido
                                }

                                ConsultaEventEx(campos, (resp) => {
                                    if (resp[0] === "fechas_duplicadas") {
                                        this.setState({
                                            cantFechasDpl: resp[1],
                                            fechasDpl: resp[2],
                                            openConfirm: true,
                                            boton2:{
                                                text:"Agregar",
                                                icon: "fa fa-plus"
                                            }
                                        })
                                    }else{
                                        this.setState({
                                            boton1: {
                                                text:"Espera",
                                                icon: "fa fa-spinner fa-spin"
                                            }
                                        }, () => {
                                            campos = {
                                                valorColor, quien, dEvent,
                                                fechaIn, fechaOut
                                            }
                                            AddNewEvento(campos, (resp) => {
                                                this.respuestaGuardar(resp)
                                            })
                                        })
                                    }
                                })
                            })
                        }}
                        ><i className={boton2.icon}></i> {boton2.text}
                        </button>
                    </Col>
                </Row>
            </React.Fragment>
        )
    }

    render() {
        let { verEvents, preloader } = this.state;
        
        let MainAyuda = (
            <Popover title="Calendario Académico" id="eventos" style={{overflowY: "auto", overflowX:"hidden", height:"80vh"}}>
                <div align="justify">
                    En este módulo puede agregar y modificar los eventos que estarán disponibles para todos los usuarios o para alguno en específico
                </div>
                <div align="justify" className="custom-mt-10">
                    En el lado izquierdo podrás ver un calendario con los dias de la semana, el cual te permitirá seleccionar una fecha o un rango de fechas
                </div>
                <div className="custom-color custom-mt-10">¿Cómo agregar un nuevo evento al calendario?</div>

                <div className="custom-color custom-mt-10"><strong>Paso 1:</strong></div>
                <div align="justify">Si deseas seleccionar un rango primero haz click en la fecha inicial y luego haz click en la fecha final, esto añadirá el rango de fechas.</div>
                <div align="justify">Si deseas seleccionar una sola fecha haz doble click en la que deseas.</div>

                <div className="custom-color custom-mt-10"><strong>Paso 2:</strong></div>
                <div align="justify">Una vez seleccioado el rango de fechas podrás ver a tu derecha el formulario de los detalles del evento.</div>
                <div align="justify">Los campos desde y hasta estan desactivados y muestran el rango que has seleccionado previamente</div>
                <div className="custom-mt-10" align="justify">Completa todos los campos y presiona el botón <button className="btn btn-primary btn-xs" style={{borderWidth:1}}><i className="fa fa-plus"></i> Agregar</button></div>

                <div className="custom-mt-20" align="center"><button className="btn btn-primary btn-xs" style={{borderWidth:1}}><i className="fa fa-search"></i> Ver Eventos del Rango de Fecha</button></div>
                <div className="custom-mt-10" align="justify">Este botón permite visualizar los eventos planificados para el rango de fechas que has seleccionado previamente. Uva vez mostrado los  eventos puedes:</div>
                <Row className="custom-mt-10">
                    <Col md={3}>
                        <button className="btn btn-warning" style={{borderWidth: 1}}><i className="fa fa-edit"></i></button>
                    </Col>
                    <Col md={9}>
                        <div align="justify">Este botón muestra los detalles del evento y te permite editarlos (cambiar de fecha, el color, la descrición y a quien esta dirigido)</div>
                    </Col>
                    <Col md={3}>
                        <button className="btn btn-danger" style={{borderWidth: 1}}><i className="fa fa-trash"></i></button>
                    </Col>
                    <Col md={9}>
                        <div align="justify">Elimina el evento de <strong>todo el rango de fecha</strong></div>
                    </Col>
                </Row>
            </Popover>
        )
        
        return(
            <React.Fragment>
                <div className="custom-alert-info" style={{backgroundColor: "#f7f7f7"}}>
                    <Row>
                        <Col md={9}>
                            <button className="btn btn-primary" onClick={this.buscarEventosRango()} style={{borderWidth:1}}><i className="fa fa-search"></i> Ver Eventos del Rango de Fecha</button>
                        </Col>
                        <Col md={3} align="right">
                            <OverlayTrigger trigger="focus" placement="left" overlay={ MainAyuda }>
                                <button className="btn btn-primary" style={{borderWidth:1}} title="Ayuda"><i className="fa fa-question-circle-o"></i> Ayuda</button>
                            </OverlayTrigger>
                        </Col>
                    </Row>
                </div>

                <div className="custom-mt-10">{this.contenidoAdd()}</div>

                <div align="center" className="text-muted" style={{fontSize: 12}}><i className={preloader.icon}></i> {preloader.text}</div>
                <div className="custom-mt-10">
                    {this.eventosFecha(verEvents)}
                </div>
                {this.confirmacion()}
                {this.delEvento()}
                {this.modalEditEvent()}
            </React.Fragment>
        )
    }
}
 
export default AddEvento;


// WEBPACK FOOTER //
// ./src/views/Academicos/CalendarioContent/AddEvento.jsx